// আপনার Worker API-র সঠিক URL
const API_URL = 'https://my-finance-api.mosharof2026.workers.dev';

// সব লেনদেন আনার ফাংশন (ঐচ্ছিক ফিল্টার সহ: startDate, endDate, description, type, accountId)
export const getTransactions = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.startDate) params.set('start_date', filters.startDate);
  if (filters.endDate) params.set('end_date', filters.endDate);
  if (filters.description) params.set('description', filters.description);
  if (filters.type) params.set('type', filters.type);
  if (filters.accountId) params.set('account_id', filters.accountId);
  const qs = params.toString();
  const res = await fetch(`${API_URL}/transactions${qs ? `?${qs}` : ''}`);
  if (!res.ok) {
    throw new Error(`HTTP error! status: ${res.status}`);
  }
  return res.json();
};

// সব অ্যাকাউন্ট আনার ফাংশন
export const getAccounts = async () => {
  const res = await fetch(`${API_URL}/accounts`);
  if (!res.ok) {
    throw new Error(`HTTP error! status: ${res.status}`);
  }
  return res.json();
};

// নতুন অ্যাকাউন্ট যোগ করার ফাংশন
export const addAccount = async (data) => {
  const res = await fetch(`${API_URL}/accounts`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    throw new Error(`HTTP error! status: ${res.status}`);
  }
  return res.json();
};

// অ্যাকাউন্ট ডিলিট করার ফাংশন
export const deleteAccount = async (id) => {
  const res = await fetch(`${API_URL}/accounts/${id}`, {
    method: 'DELETE',
  });
  if (!res.ok) {
    throw new Error(`HTTP error! status: ${res.status}`);
  }
  return res.json();
};

// অ্যাকাউন্ট-ভিত্তিক সারাংশ আনার ফাংশন
export const getSummary = async () => {
  const res = await fetch(`${API_URL}/summary`);
  if (!res.ok) {
    throw new Error(`HTTP error! status: ${res.status}`);
  }
  return res.json();
};

// নতুন লেনদেন যোগ করার ফাংশন (Transfer-এর ডাবল এন্ট্রি সহ)
export const addTransaction = async (data) => {
  const res = await fetch(`${API_URL}/transaction`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    throw new Error(`HTTP error! status: ${res.status}`);
  }
  return res.json();
};

// একটি নির্দিষ্ট লেনদেন ডিলিট করার ফাংশন
export const deleteTransaction = async (id) => {
  const res = await fetch(`${API_URL}/transaction/${id}`, {
    method: 'DELETE',
  });
  if (!res.ok) {
    throw new Error(`HTTP error! status: ${res.status}`);
  }
  return res.json();
};

// একটি নির্দিষ্ট লেনদেন আপডেট করার ফাংশন
export const updateTransaction = async (id, data) => {
  const res = await fetch(`${API_URL}/transaction/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    throw new Error(`HTTP error! status: ${res.status}`);
  }
  return res.json();
};